<script lang="ts">
  import { TestimonialCard, Quote } from './components/testimonials';
  import { Splide, SplideSlide } from '@splidejs/svelte-splide';
  import { Heading, Wrapper, ShowMoreButton } from './components';
  import type {
    GlobalProperties,
    UseFormattedProps,
  } from 'customer-components/lib/types';

  export let properties: UseFormattedProps;
  export let settings: GlobalProperties;
  // todo: where is this page coming from? is affecting to the slider's types
  // response: I think page needs to be renamed to something else since thats a reserved word
  export let page = 0;

  let innerWidth;

  $: currentItems = innerWidth >= 640 ? properties?.testimonials.length : 3;
  $: items = properties.testimonials.slice(
    0,
    currentItems,
  ) as UseFormattedProps['testimonials'];

  const showMore = () => {
    currentItems = properties.testimonials.length;
  };

  const hideItems = () => {
    currentItems = 3;
  };
</script>

<svelte:window bind:innerWidth />

<Wrapper style="background:var(--vlt-lp-secondary);">
  {#if properties}
    <div class="testimonial-section" id={properties?.anchor}>
      <div class="testimonial-content">
        <div class="title-wrapper">
          <div class="text-caps"><p>{@html properties.preamble}</p></div>
          <Heading
            type={'h2'}
            css={'text-align:center;margin-bottom:50px;color:var(--vlt-lp-secondary-text);'}
          >
            {@html properties.heading}
          </Heading>
        </div>

        {#if items.length === 1}
          {#each items as testimonial}
            <Quote
              {settings}
              text={testimonial.text}
              by={testimonial.by}
              date={testimonial.date}
              stars={testimonial.stars}
              background={testimonial.background}
            />
          {/each}
        {:else if items.length > 3 && innerWidth >= 640}
          <!-- todo: type should be start: number; -->
          <Splide
            options={{
              start: { page },
              type: 'loop',
              perPage: 3,
              gap: '1em',
              width: '100%',
              height: 'auto',
              classes: {
                prev: 'splide__arrow--prev testimonials-prev',
                next: 'splide__arrow--next testimonials-next',
              },
              breakpoints: {
                1100: {
                  perPage: 2,
                },
                640: {
                  destroy: true,
                },
              },
              pagination: true,
            }}
          >
            {#each items as testimonial}
              <SplideSlide>
                <TestimonialCard
                  isSlide
                  by={testimonial.by}
                  text={testimonial.text}
                  alignment={testimonial.alignment}
                  rating={testimonial.stars}
                />
              </SplideSlide>
            {/each}
          </Splide>
        {:else}
          <div class="testimonials">
            {#each items as testimonial}
              <TestimonialCard
                by={testimonial.by}
                text={testimonial.text}
                alignment={testimonial.alignment}
                rating={testimonial.stars}
              />
            {/each}
          </div>
        {/if}
      </div>
    </div>

    {#if innerWidth <= 640}
      <div class="show-more-btn">
        <ShowMoreButton
          on:showMore={showMore}
          on:showLess={hideItems}
          {currentItems}
          itemsLength={properties.testimonials.length}
        />
      </div>
    {/if}
  {/if}
</Wrapper>

<style>
  .testimonial-section {
    max-width: 1480px;
    margin: auto;
  }
  .testimonial-content {
    display: flex;
    align-items: center;
    justify-content: center;
    flex-direction: column;
    padding: 0 90px;
  }
  .title-wrapper {
    text-align: center;
  }
  .text-caps {
    font-style: normal;
    font-weight: 500;
    font-size: 16px;
    line-height: 26px;
    text-align: center;
    letter-spacing: 0.1em;
    text-transform: uppercase;
    color: #919197;
  }
  .testimonials {
    display: flex;
    grid-column-gap: 32px;
    grid-row-gap: 32px;
    -ms-grid-columns: 1fr 1fr 1fr;
    grid-template-columns: 1fr 1fr 1fr;
    -ms-grid-rows: auto;
    margin-top: 20px;
    grid-template-rows: auto;
    font-family: var(--text-font, 'DM Sans');
  }
  .testimonial-content :global(.splide__track) {
    padding-right: 0 !important;
  }
  .testimonial-content :global(.splide__list) {
    align-items: stretch;
  }
  :global(.testimonials-prev) {
    left: -80px !important;
  }
  :global(.testimonials-next) {
    right: -80px !important;
  }
  .testimonial-content :global(.splide__pagination) {
    bottom: -30px;
  }
  :global(.splide__pagination__page.is-active) {
    background: #5373f0;
    opacity: 1;
  }
  :global(.splide__pagination__page) {
    transform: scale(1.4);
    background: #f4f4f5;
    opacity: 1;
  }
  :global(.splide__pagination li) {
    margin-left: 15px;
  }
  :global(.splide__arrow) {
    width: 60px;
    height: 60px;
    background: #f4f4f5;
  }
  .show-more-btn :global(button) {
    color: var(--vlt-lp-secondary-text);
    border: 1px solid var(--vlt-lp-secondary-text);
  }

  @media screen and (max-width: 990px) {
    .testimonials {
      display: grid;
      grid-template-columns: 1fr 1fr;
    }
    .testimonial-content {
      padding: 0px 15px;
    }
    :global(.testimonials-prev) {
      left: 0 !important;
    }
    :global(.testimonials-next) {
      right: 0 !important;
    }
  }
  @media screen and (max-width: 767px) {
    .testimonials {
      grid-template-columns: 1fr;
    }
    .testimonial-content {
      padding: 0 15px !important;
    }
    .testimonial-content :global(.splide__pagination) {
      bottom: -20px;
    }
  }
  @media screen and (max-width: 640px) {
    .testimonial-content :global(.testimonial-card) {
      margin-bottom: 10px;
    }
  }
</style>
